import { render, staticRenderFns } from "./ldy.vue?vue&type=template&id=5011bfd3&scoped=true&"
import script from "./ldy.vue?vue&type=script&lang=js&"
export * from "./ldy.vue?vue&type=script&lang=js&"
import style0 from "./ldy.vue?vue&type=style&index=0&id=5011bfd3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5011bfd3",
  null
  
)

export default component.exports